<div class="card border border-light shadow mb-3" *ngIf="filteredExternalLinks?.length > 0">
    <div class="card-header bg-light">
        <h4 style="margin: 3px;">External Links</h4>
    </div>
    <div class="card-body">
        <div class="d-none d-sm-block">
            <div class="row" style="margin-left:10px">
                <ng-container *ngFor="let externalLink of filteredExternalLinks;">
                    <div class="row col-xl-6 col-lg-6 col-md-12"
                         style="margin-bottom:25px; max-height:800px; margin-right:15px; overflow-wrap:anywhere;">
                        <a [href]="externalLink.link" [target]="'_blank'" style="cursor:pointer;">
                            <i class="modus-icons align-bottom" aria-hidden="true">link</i>
                            {{ externalLink.text ? externalLink.text : externalLink.link }}
                        </a>
                    </div>
                </ng-container>
            </div>
        </div>
        <!-- Mobile View -->
        <div class="d-block d-sm-none">
            <div *ngFor="let externalLink of filteredExternalLinks; last as isLast"
                 [ngClass]="{'border-bottom': !isLast}" class="row" style="padding: 10px;">
                <div class="col-sm-12">
                    <a [href]="externalLink.link" [target]="'_blank'" style="cursor:pointer;">
                        <i class="modus-icons align-bottom" aria-hidden="true">link</i>
                        {{ externalLink.text ? externalLink.text : externalLink.link }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>